import React from 'react';

const badgeColors = {
    RESTOCK: 'bg-green-100 text-green-800',
    INVESTIGATE: 'bg-yellow-100 text-yellow-800',
    HOLD: 'bg-gray-100 text-gray-600',
};

export default function RestockAlerts({ data }) {
    if (!data || data.length === 0) {
        return <p className="text-gray-500 py-4">No restock alerts at this time.</p>;
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Alert</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Avail</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Sold/30d</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Rev/30d</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">BB Win%</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Competitors</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Fee%</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Return%</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Recommendation</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                            <td className="px-3 py-3 text-sm">
                                <div className="font-medium text-gray-900 truncate max-w-[200px]" title={item.productName}>
                                    {item.productName}
                                </div>
                                <div className="text-xs text-gray-400">{item.asin}</div>
                            </td>
                            <td className="px-3 py-3 text-sm text-gray-600">{item.alert}</td>
                            <td className="px-3 py-3 text-sm text-right">{item.available}</td>
                            <td className="px-3 py-3 text-sm text-right">{item.unitsSoldLast30Days}</td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.revenueLast30Days != null ? `$${Number(item.revenueLast30Days).toFixed(0)}` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">{item.bbWinPct}%</td>
                            <td className="px-3 py-3 text-sm text-right">{item.competitorCount}</td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.estimatedFeePct != null ? `${Number(item.estimatedFeePct).toFixed(1)}%` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">{item.returnRatePct}%</td>
                            <td className="px-3 py-3 text-sm">
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badgeColors[item.recommendation] || 'bg-gray-100 text-gray-600'}`}>
                                    {item.recommendation}
                                </span>
                                <div className="text-xs text-gray-400 mt-1">{item.recommendationReason}</div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
